import { MOCK_INVITE_SUPPLIER_TOKEN, MOCK_INVITE_SUPPORTER_TOKEN } from "@/api/invitation";
import { Command } from "@givenwell/command-palette";
import { CogIcon } from "@givenwell/core-solid-icons";

export const mockSupporterOnboardingCommand: Command = {
  id: "mock-onboarding-supporter",
  title: "Run Mock Supporter Onboarding Flow",
  icon: <CogIcon width="21" />,
  onSelect: () => {
    // @ts-expect-error
    window.location = `/invitation/activate?token=${encodeURIComponent(MOCK_INVITE_SUPPORTER_TOKEN)}`;
  },
};
export const mockSupplierOnboardingCommand: Command = {
  id: "mock-onboarding-supplier",
  title: "Run Mock Supplier Onboarding Flow",
  icon: <CogIcon width="21" />,
  onSelect: () => {
    // @ts-expect-error
    window.location = `/invitation/activate?token=${encodeURIComponent(MOCK_INVITE_SUPPLIER_TOKEN)}`;
  },
};
